import { render, staticRenderFns } from "./docDetail.vue?vue&type=template&id=85790380&"
import script from "./docDetail.vue?vue&type=script&lang=js&"
export * from "./docDetail.vue?vue&type=script&lang=js&"
import style0 from "./docDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports